var _path, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58172 0 0 3.58172 0 8L0 8.012C0 12.4303 3.56972 16 7.988 16L8 16C12.4183 16 16 12.4303 16 8.012L16 8C16 3.58172 12.4303 0 8.012 0L8 0Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 0 0)",
    fill: "rgb(113, 113, 238)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3306229542"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L16 0L16 16L0 16L0 0Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3306229542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.24267 6.12867L10.3707 0L11.314 0.942667L4.24267 8.014L0 3.77133L0.942667 2.82867L4.24267 6.12867Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 2.424 3.986)",
    fill: "rgb(255, 255, 255)"
  }))));
};
export default SvgSuccess;